import React from "react";
import styles from "./SectionPage.module.scss";
import cn from "classnames";
import {Container} from "react-bootstrap";
import LazyImage from "../LazyImage/LazyImage";

interface SectionPageProps {
    idHash?: string,
    title?: string,
    children: React.ReactNode,
    className?: string | Array<keyof typeof styles>;
}

const SectionPage: React.FC<SectionPageProps> = ({idHash, title, children, className}) => {
    return (
        <div id={idHash}
             className={cn(styles.sectionPage, Array.isArray(className)
                 ? className.map(cls => styles[cls] || cls)
                 : className)}
        >
            <LazyImage className={styles.sectionPageImage}
                       src="./assets/images/general/bgTheme.png"
                       alt={title}/>
            <Container>
                {title &&
                    <h2 className={styles.sectionPageTitle}>
                        {title}
                    </h2>
                }
                {children}
            </Container>
        </div>
    )
}

export default SectionPage;